import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import GpsDeviceFormComponent from "./_form"

interface GpsDeviceForm {
  id: number
  name: string
  serial_number: string
  start_date: string | null
  end_date: string | null
  log: string
  sort_order: number | null
  notes: string
  current_user_id: number | null
}

interface Investigator {
  id: number
  name: string
}

interface Props {
  gps_device: GpsDeviceForm
  investigators: Investigator[]
  errors?: Record<string, string[]>
}

export default function Edit({ gps_device, investigators, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "GPS Devices", href: "/gps_devices" },
    { title: "Edit GPS Device", href: `/gps_devices/${gps_device.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Edit GPS Device" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Edit GPS Device</h1>

        <GpsDeviceFormComponent
          gps_device={gps_device}
          investigators={investigators}
          errors={errors}
          submitUrl={`/gps_devices/${gps_device.id}`}
          submitMethod="patch"
        />
      </div>
    </AppLayout>
  )
}
